import { PrimaryCtaEnum } from 'generated/graphql';
import type { CtaTopConfigInterface } from './constants';
import {
    PRIMARY_CTA_CONFIG,
    PRIMARY_CTA_CONFIG_UNDEFINED_PAGETYPE,
    PRIMARY_CTA_MANAFACTURER,
} from './constants';

export interface PrimaryCTAResult {
    primaryCTA: PrimaryCtaEnum;
    primaryCTALabel: string;
    primaryCTALabelTitleCase: string;
    primaryCTALabelShort: string;
    primaryCTAFormTitle: string;
}

interface PrimaryCTAOpts {
    primaryCTA?: PrimaryCtaEnum;
    pageType?: keyof CtaTopConfigInterface<never>;
    professionalPrimaryCategory?: string;
    isManufacturer?: boolean;
}

export const getPrimaryCTA = (opts: PrimaryCTAOpts) => {
    const {
        primaryCTA = PrimaryCtaEnum.AutoOptimise,
        pageType,
        professionalPrimaryCategory,
        isManufacturer,
    } = opts;

    const { label, labelTitleCase, labelShort } =
        pageType === undefined
            ? //If no page type check if the primary cat is set
              professionalPrimaryCategory === undefined
                ? PRIMARY_CTA_CONFIG_UNDEFINED_PAGETYPE
                : getCtaProfessionalPrimaryCategory(professionalPrimaryCategory)
            : //Check if prof is manafactyrer and correct cat
            //If true show MANAFACTURER cta
            pageType === 'professional' &&
              isManufacturer &&
              primaryCTA === PrimaryCtaEnum.AutoOptimise
            ? PRIMARY_CTA_MANAFACTURER
            : PRIMARY_CTA_CONFIG[pageType][primaryCTA];

    return {
        primaryCTA: primaryCTA,
        primaryCTALabel: label,
        primaryCTALabelTitleCase: labelTitleCase,
        primaryCTALabelShort: labelShort,
        primaryCTAFormTitle: labelTitleCase,
    };
};

const getCtaProfessionalPrimaryCategory = (
    professionalPrimaryCategory: string
) => ({
    label: `Message ${professionalPrimaryCategory}`,
    labelTitleCase: `Message ${professionalPrimaryCategory}`,
    labelShort: PRIMARY_CTA_CONFIG_UNDEFINED_PAGETYPE.labelShort,
});
